import { BodyText, Flex, Heading } from '@utilitywarehouse/hearth-react';

import { DocumentLink } from '@components/DocumentLink';
import { InsuranceDocument } from '@generated/gql/graphql';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupIpDocumentClicked } from '@tracking/trackingEvents';

import './styles.scss';

interface PolicyDocumentsProps {
  documents: InsuranceDocument[];
}

const PolicyDocuments: React.FC<PolicyDocumentsProps> = ({ documents }) => {
  const { trackingContexts } = useTrackingContext();
  const trackDocClick = useTrackSignupIpDocumentClicked();

  const handleDocClick = (documentTitle: string) => {
    trackDocClick(
      {
        document_title: documentTitle,
      },
      { contexts: trackingContexts }
    );
  };
  if (!documents) return null;
  return (
    <Flex
      spacing="lg"
      direction="column"
      className="incomeProtectorDocuments__Wrapper"
    >
      <Heading as="h3" size="lg">
        Policy documents
      </Heading>
      <BodyText>
        Your cover will begin on the first day of the next calendar month, after
        we’ve reviewed and approved your application. We’ll send you an email
        with your personalised documents when your policy starts.
      </BodyText>
      <Flex spacing="lg" direction="column" alignItems="start" asChild>
        <div data-testid="income-protector-documents">
          {documents.map((item) => (
            <DocumentLink
              key={item.name}
              name={item.name}
              url={item.url}
              onClick={handleDocClick}
            />
          ))}
        </div>
      </Flex>
    </Flex>
  );
};

export { PolicyDocuments };
